import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=2fa44267&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"
import style0 from "./approve.vue?vue&type=style&index=0&id=2fa44267&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa44267",
  null
  
)

export default component.exports